import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const role = localStorage.getItem("sc_google_role") || undefined;
    const room_id = localStorage.getItem("sc_google_room") || undefined;
    const slot_id = localStorage.getItem("sc_google_slot") || undefined;
    localStorage.removeItem("sc_google_role");
    localStorage.removeItem("sc_google_room");
    localStorage.removeItem("sc_google_slot");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, role, room_id, slot_id });
        await refresh();
        toast.success(`Bienvenue ${data.name.split(" ")[0]} !`);
        window.history.replaceState(null, "", location.pathname);
        navigate(data.redirect_to || "/tableau-de-bord", { replace: true });
      } catch (e) {
        toast.error(e.response?.data?.detail || "Connexion Google échouée");
        window.history.replaceState(null, "", "/connexion");
        navigate("/connexion", { replace: true });
      }
    })();
  }, [location, navigate, refresh]);

  return <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center text-slate-500">Connexion en cours…</div>;
}
